import { render } from "./MutualsettlementsTable.vue?vue&type=template&id=048afe16&scoped=true"
import script from "./MutualsettlementsTable.vue?vue&type=script&lang=js"
export * from "./MutualsettlementsTable.vue?vue&type=script&lang=js"

import "./MutualsettlementsTable.vue?vue&type=style&index=0&id=048afe16&scoped=true&lang=css"
import "./MutualsettlementsTable.vue?vue&type=style&index=1&id=048afe16&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048afe16"]])

export default __exports__